interface CustomIconLinkChannelProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconLinkChannel({ width, height }: CustomIconLinkChannelProps) {
  return (
    <svg width={width || 32} height={height || 32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.4473 17.6333L11.7368 23.4213C10.6548 25.1092 8.33408 25.4587 6.80295 24.1642V24.1642C5.5206 23.0801 5.25076 21.2086 6.1746 19.8064L10.0001 13.9999L12.6667 15.9999"
        stroke="#1C1C28"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.2971 11.8411L15.3212 6.16918C16.4324 4.60294 18.6029 4.23406 20.1691 5.34526V5.34526C21.7353 6.45646 22.1042 8.62696 20.993 10.1932L16.969 15.8651L14.1331 13.8531"
        stroke="#1C1C28"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
